// extracted by mini-css-extract-plugin
export default {"espacamento":"Calendario_espacamento__IVY6g","label":"Calendario_label__ri0lu"};